/* eslint-disable no-plusplus */
/* eslint-disable one-var */
// @mui material components
import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  // DialogActions,
  Chip,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  Grid,
  Icon,
  DialogActions,
  // Checkbox,
  // FormLabel,
  // Stack,
} from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios.js";
import MDTypography from "components/MDTypography";
// import Editor from "react-simple-wysiwyg";
// import MDTypography from "components/MDTypography";
// import AppConfig from "appConfig";
import kycImg2 from "assets/images/kyc/face_scan.webp";
import kycImg from "assets/images/kyc/kyc_prompt.png";

import Multiselect from "multiselect-react-dropdown";
import AppConfig from "appConfig";

function ProfilerDialog() {
  const navigate = useNavigate();

  const [showProfilerDialog, setShowProfilerDialog] = useState(true);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [tags, setTags] = useState([]);
  const [educationLevels, setEducationLevels] = useState([]);
  const [experienceLevels, setExperienceLevels] = useState([]);
  const [customerMarkets, setCustomerMarkets] = useState([]);
  const [step, setStep] = useState(0);
  const dailySales = [
    { value: 1, name: "1 Sale" },
    { value: 3, name: "3 Sales" },
    { value: 5, name: "5 Sales" },
    { value: 10, name: "More than 5 Sales" },
  ];

  const [education, setEducation] = useState(null);
  const [experience, setExperience] = useState(null);
  const [dailyTarget, setDailyTarget] = useState(null);
  const [preferences, setPreferences] = useState(new Set());
  const [community, setCommunity] = useState(new Set());
  const [previous, setPrevious] = useState(new Set());
  const [selectedCustomerMarkets, setSelectedCustomerMarkets] = useState(new Set());

  const [mpreferences, setMPreferences] = useState([]);
  const [mprevious, setMPrevious] = useState([]);
  const [mcommunity, setMCommunity] = useState([]);

  const [tagsPreference, setTagsPreference] = useState([]);
  const [tagsPrevious, setTagsPrevious] = useState([]);
  const [tagsCommunity, setTagsCommunity] = useState([]);

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      // Generate random number
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }

    return array;
  }

  useEffect(() => {
    const xArr = [];
    preferences.forEach((item) => {
      tags.every((ele) => {
        if (ele.reference === item) {
          xArr.push(ele);
          return false;
        }
        return true;
      });
    });
    setMPreferences(xArr);
  }, [preferences]);

  useEffect(() => {
    const xArr = [];
    previous.forEach((item) => {
      tags.every((ele) => {
        if (ele.reference === item) {
          xArr.push(ele);
          return false;
        }
        return true;
      });
    });
    setMPrevious(xArr);
  }, [previous]);

  useEffect(() => {
    const xArr = [];
    community.forEach((item) => {
      tags.every((ele) => {
        if (ele.reference === item) {
          xArr.push(ele);
          return false;
        }
        return true;
      });
    });
    setMCommunity(xArr);
  }, [community]);

  // const [subject, setSubject] = useState(null);
  // const [messageBody, setMessageBody] = useState(null);

  async function submitProfile() {
    if (education === null) {
      setSeverity("error");
      setErrMsg("Education level is required.");
      setOpen(true);
      return;
    }

    if (experience === null) {
      setSeverity("error");
      setErrMsg("Experience level is required.");
      setOpen(true);
      return;
    }

    if (preferences.size < 5) {
      setSeverity("error");
      setErrMsg("Please select at least 5 products you can sell easily.");
      setOpen(true);
      return;
    }

    if (previous.size < 3) {
      setSeverity("error");
      setErrMsg("Please select at least 3 products you've sold in the past.");
      setOpen(true);
      return;
    }

    if (community.size < 5) {
      setSeverity("error");
      setErrMsg("Please select at least 5 products your family and friends want.");
      setOpen(true);
      return;
    }

    if (selectedCustomerMarkets.size < 3) {
      setSeverity("error");
      setErrMsg("Please select at least 3 places you best sell in.");
      setOpen(true);
      return;
    }

    if (dailyTarget === null) {
      setSeverity("error");
      setErrMsg("Please set your daily sales target.");
      setOpen(true);
      return;
    }

    setShowLoading(true);

    const json = {
      sales_preferences: Array.from(preferences),
      sales_community: Array.from(community),
      sales_previous: Array.from(previous),
      educational_level: education,
      experience_level: experience,
      customer_markets: Array.from(selectedCustomerMarkets),
      daily_target: dailyTarget,
    };

    await axios
      .post("agents/profiler/submit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
          setStep(8);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function next() {
    if (step === 1) {
      if (education === null) {
        setSeverity("error");
        setErrMsg("Please select your highest educational.");
        setOpen(true);
        return false;
      }
    }

    if (step === 2) {
      if (experience === null) {
        setSeverity("error");
        setErrMsg("Please select your sales experience level.");
        setOpen(true);
        return false;
      }
    }

    if (step === 3) {
      if (preferences.size < 5) {
        setSeverity("error");
        setErrMsg("Please select at least 5 options.");
        setOpen(true);
        return false;
      }
    }

    if (step === 4) {
      if (previous.size < 3) {
        setSeverity("error");
        setErrMsg("Please select at least 3 options.");
        setOpen(true);
        return false;
      }
    }

    if (step === 5) {
      if (community.size < 5) {
        setSeverity("error");
        setErrMsg("Please select at least 5 options.");
        setOpen(true);
        return false;
      }
    }

    if (step === 6) {
      if (selectedCustomerMarkets.size !== 3) {
        setSeverity("error");
        setErrMsg("Please select your top 3 places only.");
        setOpen(true);
        return false;
      }
    }

    if (step === 7) {
      if (dailySales === null) {
        setSeverity("error");
        setErrMsg("Please select your daily sales target.");
        setOpen(true);
        return false;
      }
    }

    return true;
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/profiler.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setTags(result.data.data.tags);
            setCustomerMarkets(result.data.data.customer_markets);
            setTagsPreference(shuffleArray(result.data.data.tags));
            setTagsPrevious(shuffleArray(result.data.data.tags));
            setTagsCommunity(shuffleArray(result.data.data.tags));
            setEducationLevels(result.data.data.educational_levels);
            setExperienceLevels(result.data.data.experience_levels);
            setStep(0);
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={showProfilerDialog} fullWidth maxWidth="md">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MDBox m={2}>
          {step === 0 ? (
            <>
              <DialogTitle>
                <MDBox align="center">
                  <MDBox>We&apos;d like to know more about you!</MDBox>
                  <MDTypography variant="h6" fontWeight="light">
                    This is required to help us find the right products you can sell and increase
                    your chances of getting hired for sales and social media promotions.{" "}
                    <strong>It will take less than a minute of your time.</strong>
                  </MDTypography>
                </MDBox>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox mt={5} align="center">
                    <MDBox mt={3} mb={5}>
                      <img src={kycImg2} alt="" width={200} />
                    </MDBox>
                    <MDBox mt={5} align="center">
                      <MDButton
                        onClick={() => {
                          let x = step;
                          x += 1;
                          setStep(x);
                        }}
                        color="info"
                        variant="outlined"
                      >
                        <Icon>chevron_right</Icon> Proceed
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 8 ? (
            <>
              <DialogTitle>
                <MDBox align="center">
                  <MDBox>You are done!</MDBox>
                  <MDTypography variant="h6" fontWeight="light">
                    Thanks for making out time to take the survey.
                  </MDTypography>
                </MDBox>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox mt={5} align="center">
                    {/* <MDBox mt={3} mb={5}>
                      <Icon
                        fontSize="large"
                        sx={{ fontSize: 240 }}
                        color="success"
                        variant="outlined"
                      >
                        check_circle_outline
                      </Icon>
                    </MDBox> */}
                    <MDBox mt={3} mb={5}>
                      <img src={kycImg} alt="" width={200} />
                    </MDBox>
                    <MDBox mt={5} align="center">
                      <MDButton
                        onClick={() => {
                          setShowProfilerDialog(false);
                          AppConfig.profile_reqd = false;
                          navigate("/gigs");
                        }}
                        color="info"
                        variant="outlined"
                      >
                        <Icon>close</Icon> Dismiss
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 1 ? (
            <>
              <DialogTitle>
                <MDBox>{step}. What&apos;s your highest educational level?</MDBox>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox p={2}>
                    <FormControl>
                      <RadioGroup
                        value={education}
                        onChange={(e) => {
                          setEducation(e.target.value);
                        }}
                      >
                        {
                          // --> Notice below changes
                          educationLevels.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            educationLevels.map((record) => (
                              <FormControlLabel
                                value={record.reference}
                                control={<Radio />}
                                label={
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {record.title}
                                  </MDTypography>
                                }
                              />
                            ))
                        }
                      </RadioGroup>
                    </FormControl>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 2 ? (
            <>
              <DialogTitle>
                <MDBox>{step}. How experienced are you in selling?</MDBox>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox>
                    <FormControl>
                      <RadioGroup
                        value={experience}
                        onChange={(e) => {
                          setExperience(e.target.value);
                        }}
                      >
                        {
                          // --> Notice below changes
                          experienceLevels.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            experienceLevels.map((record) => (
                              <FormControlLabel
                                value={record.reference}
                                control={<Radio />}
                                label={
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {record.title}
                                  </MDTypography>
                                }
                              />
                            ))
                        }
                      </RadioGroup>
                    </FormControl>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 3 ? (
            <>
              <DialogTitle>
                <MDBox>{step}. What products or services can you sell easily?</MDBox>
                <MDTypography ml={3} variant="h6" fontWeight="light">
                  Select at least 5 options below.
                </MDTypography>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox mt={3} mb={3}>
                    <Multiselect
                      options={tags} // Options to display in the dropdown
                      selectedValues={mpreferences} // Preselected value to persist in dropdown
                      onSelect={(selectedList, selectedItem) => {
                        const newSet = new Set(preferences);
                        if (!newSet.has(selectedItem.reference)) {
                          newSet.add(selectedItem.reference);
                          setPreferences(newSet);
                        }
                      }} // Function will trigger on select event
                      onRemove={(selectedList, removedItem) => {
                        const newSet = new Set(preferences);
                        if (newSet.has(removedItem.reference)) {
                          newSet.delete(removedItem.reference);
                          setPreferences(newSet);
                        }
                      }} // Function will trigger on remove event
                      displayValue="title" // Property name to display in the dropdown options
                      showCheckbox={false}
                      placeholder="Type to search"
                      avoidHighlightFirstOption
                    />
                  </MDBox>
                  <MDBox mt={5}>
                    <Grid container spacing={1} sx={{ overflowY: "scroll", maxHeight: "320px" }}>
                      {
                        // --> Notice below changes
                        tagsPreference.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          tagsPreference.map((record) => (
                            <Grid item>
                              <Chip
                                size="small"
                                color="info"
                                label={record.title}
                                variant={preferences.has(record.reference) ? "filled" : "outlined"}
                                onClick={() => {
                                  const newSet = new Set(preferences);
                                  if (newSet.has(record.reference)) {
                                    newSet.delete(record.reference);
                                  } else {
                                    newSet.add(record.reference);
                                  }
                                  setPreferences(newSet);
                                }}
                              />
                            </Grid>
                          ))
                      }
                    </Grid>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 4 ? (
            <>
              <DialogTitle>
                <MDBox>{step}. Which products or services have you sold before?</MDBox>
                <MDTypography ml={3} variant="h6" fontWeight="light">
                  Select at least 3 option below.
                </MDTypography>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox mt={3} mb={3}>
                    <Multiselect
                      options={tags} // Options to display in the dropdown
                      selectedValues={mprevious} // Preselected value to persist in dropdown
                      onSelect={(selectedList, selectedItem) => {
                        const newSet = new Set(previous);
                        if (!newSet.has(selectedItem.reference)) {
                          newSet.add(selectedItem.reference);
                          setPrevious(newSet);
                        }
                      }} // Function will trigger on select event
                      onRemove={(selectedList, removedItem) => {
                        const newSet = new Set(previous);
                        if (newSet.has(removedItem.reference)) {
                          newSet.delete(removedItem.reference);
                          setPrevious(newSet);
                        }
                      }} // Function will trigger on remove event
                      displayValue="title" // Property name to display in the dropdown options
                      showCheckbox={false}
                      placeholder="Type to search"
                      avoidHighlightFirstOption
                    />
                  </MDBox>
                  <MDBox mt={5}>
                    <Grid container spacing={1} sx={{ overflowY: "scroll", maxHeight: "320px" }}>
                      {
                        // --> Notice below changes
                        tagsPrevious.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          tagsPrevious.map((record) => (
                            <Grid item>
                              <Chip
                                size="small"
                                color="info"
                                label={record.title}
                                variant={previous.has(record.reference) ? "filled" : "outlined"}
                                onClick={() => {
                                  const newSet = new Set(previous);
                                  if (newSet.has(record.reference)) newSet.delete(record.reference);
                                  else newSet.add(record.reference);
                                  setPrevious(newSet);
                                }}
                              />
                            </Grid>
                          ))
                      }
                    </Grid>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 5 ? (
            <>
              <DialogTitle>
                <MDBox>
                  {step}. Which products or services are your family, friends or community likely to
                  buy?
                </MDBox>
                <MDTypography ml={3} variant="h6" fontWeight="light">
                  Select at least 5 options below.
                </MDTypography>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox mt={3} mb={3}>
                    <Multiselect
                      options={tags} // Options to display in the dropdown
                      selectedValues={mcommunity} // Preselected value to persist in dropdown
                      onSelect={(selectedList, selectedItem) => {
                        const newSet = new Set(community);
                        if (!newSet.has(selectedItem.reference)) {
                          newSet.add(selectedItem.reference);
                          setCommunity(newSet);
                        }
                      }} // Function will trigger on select event
                      onRemove={(selectedList, removedItem) => {
                        const newSet = new Set(community);
                        if (newSet.has(removedItem.reference)) {
                          newSet.delete(removedItem.reference);
                          setCommunity(newSet);
                        }
                      }} // Function will trigger on remove event
                      displayValue="title" // Property name to display in the dropdown options
                      showCheckbox={false}
                      placeholder="Type to search"
                      avoidHighlightFirstOption
                    />
                  </MDBox>
                  <MDBox mt={5}>
                    <Grid container spacing={1} sx={{ overflowY: "scroll", maxHeight: "320px" }}>
                      {
                        // --> Notice below changes
                        tagsCommunity.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          tagsCommunity.map((record) => (
                            <Grid item>
                              <Chip
                                size="small"
                                color="info"
                                label={record.title}
                                variant={community.has(record.reference) ? "filled" : "outlined"}
                                onClick={() => {
                                  const newSet = new Set(community);
                                  if (newSet.has(record.reference)) newSet.delete(record.reference);
                                  else newSet.add(record.reference);
                                  setCommunity(newSet);
                                }}
                              />
                            </Grid>
                          ))
                      }
                    </Grid>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 6 ? (
            <>
              <DialogTitle>
                <MDBox>{step}. In what places and locations do you sell best?</MDBox>
                <MDTypography ml={3} variant="h6" fontWeight="light">
                  Select 3 options.
                </MDTypography>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox mt={3}>
                    <Grid container spacing={1} sx={{ overflowY: "scroll", maxHeight: "320px" }}>
                      {
                        // --> Notice below changes
                        customerMarkets.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          customerMarkets.map((record) => (
                            <Grid item>
                              <Chip
                                size="small"
                                color="info"
                                label={record.title}
                                variant={
                                  selectedCustomerMarkets.has(record.reference)
                                    ? "filled"
                                    : "outlined"
                                }
                                onClick={() => {
                                  const newSet = new Set(selectedCustomerMarkets);
                                  if (newSet.has(record.reference)) newSet.delete(record.reference);
                                  else newSet.add(record.reference);
                                  setSelectedCustomerMarkets(newSet);
                                }}
                              />
                            </Grid>
                          ))
                      }
                    </Grid>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step === 7 ? (
            <>
              <DialogTitle>
                <MDBox>{step}. How many sales can you make in a day?</MDBox>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <MDBox>
                    <FormControl>
                      <RadioGroup
                        value={dailyTarget}
                        onChange={(e) => {
                          setDailyTarget(e.target.value);
                        }}
                      >
                        {
                          // --> Notice below changes
                          dailySales.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            dailySales.map((record) => (
                              <FormControlLabel
                                value={record.value}
                                control={<Radio />}
                                label={
                                  <MDTypography variant="h6" fontWeight="regular">
                                    {record.name}
                                  </MDTypography>
                                }
                              />
                            ))
                        }
                      </RadioGroup>
                    </FormControl>
                  </MDBox>
                </DialogContentText>
              </DialogContent>
            </>
          ) : (
            <> </>
          )}
          {step > 0 && step < 8 ? (
            <MDBox mt={5} p={2}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    {step > 1 ? (
                      <MDButton
                        iconOnly
                        circular
                        onClick={() => {
                          let x = step;
                          x -= 1;
                          if (x === 1) {
                            x = 1;
                          }
                          setStep(x);
                        }}
                        color="dark"
                        variant="outlined"
                      >
                        <Icon>chevron_left</Icon>
                      </MDButton>
                    ) : (
                      <> </>
                    )}
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox align="right">
                    <MDButton
                      iconOnly
                      circular
                      onClick={() => {
                        if (next() === false) {
                          return;
                        }
                        if (step === 7) {
                          submitProfile();
                          return;
                        }
                        let x = step;
                        x += 1;
                        setStep(x);
                      }}
                      color={step === 7 ? "success" : "dark"}
                      variant={step === 7 ? "contained" : "outlined"}
                    >
                      <Icon>{step === 7 ? "check" : "chevron_right"}</Icon>
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          ) : (
            <> </>
          )}
        </MDBox>
        <DialogActions>
          <MDButton
            onClick={() => {
              AppConfig.profile_reqd = false;
              setShowProfilerDialog(false);
            }}
            color="dark"
            variant="outlined"
            startIcon={<Icon>cancel</Icon>}
          >
            Not Now
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ProfilerDialog;
